/**
*
* StudentConsentItems
*
*/

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UserText from 'components/media/UserText/Loadable.js';
import { Card, ListGroup, ListGroupItem } from 'react-bootstrap';
import { useApi2, useApi2call } from 'containers/Api2/index.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import { PARENT_ROLE } from 'containers/User/constants.js';
import InfoButton from 'components/interaction/InfoButton/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import messages from './messages.js';
import consentItemsByCategory from '../consentItemsByCategory.js';
import ConsentMeta from './ConsentMeta.jsx';
import ConsentControl from './ConsentControl.jsx';

function StudentConsentItems(props) {
  const { studentId } = props;
  const url = `students/${studentId}/consentitems`;
  const consentItems = useApi2({ url });
  const categories = useMemo(() => consentItemsByCategory(consentItems));
  const api2call = useApi2call();
  const role = useCurrentRole();
  const handleChange = role.type === PARENT_ROLE
    ? ((id, consent) => api2call({
      method: 'POST',
      url,
      body: {
        values: [{ id, consent }],
      },
      withPromise: true,
    }))
    : undefined;

  function renderBody() {
    if (!categories) {
      return <Spinner />;
    }
    if (categories.length === 0) {
      return <FormattedMessage {...messages.noItems} />;
    }
    return (
      categories.map((cat) => (
        <div key={cat.id} className="mt-5">
          <h3>{cat.title}</h3>
          <ListGroup className="mb-3 mx-n4 flush">
            {cat.items.map((item) => (
              <ListGroupItem key={item.id} className="d-flex">
                <span className="flex-grow-1">
                  {item.title}
                  {item.description && <InfoButton><UserText>{item.description}</UserText></InfoButton>}
                </span>
                <ConsentMeta item={item} />
                <ConsentControl item={item} onChange={handleChange} />
              </ListGroupItem>
            ))}
          </ListGroup>
        </div>
      ))
    );
  }

  return (
    <Card>
      <Card.Body>
        <Card.Title as="h2"><FormattedMessage {...messages.header} /></Card.Title>
        {renderBody()}
      </Card.Body>
    </Card>
  );
}

StudentConsentItems.propTypes = {
  studentId: PropTypes.number,
};

export default StudentConsentItems;
